import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { AuditComment } from "modules/charts-shared/types/audit-comments";

type UseAuditComments = {
  encounterId: string;
  chartCode: string;
  sectionCode: string;
  subsectionCode?: string;
};

type UseAuditCommentsShared = {
  encounterId: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useAuditComments(props: UseAuditComments) {
  const { chartCode, sectionCode, encounterId, subsectionCode } = props;
  const endpoint = subsectionCode
    ? `/v1/audits/subsection/comments/${encounterId}/${chartCode}/${sectionCode}/${subsectionCode}`
    : `/v1/audits/section/comments/${encounterId}/${chartCode}/${sectionCode}`;

  return useAxiosQuery(
    ["AuditComments", { chartCode, sectionCode, encounterId, subsectionCode }],
    () => axiosChartInstance.get<AuditComment[]>(endpoint, {}),
    { staleTime: 1 * 30 * 1000 }
  );
}

function useAuditCommentsShared(props: UseAuditCommentsShared) {
  const { sectionCode, encounterId, subsectionCode } = props;
  const endpoint = subsectionCode
    ? `/v1/audits/subsection/comments/${encounterId}/shared/${sectionCode}/${subsectionCode}`
    : `/v1/audits/section/comments/${encounterId}/shared/${sectionCode}`;

  return useAxiosQuery(
    ["AuditCommentsShared", { sectionCode, encounterId, subsectionCode }],
    () => axiosChartInstance.get<AuditComment[]>(endpoint, {}),
    { staleTime: 1 * 30 * 1000 }
  );
}

export { useAuditComments, useAuditCommentsShared };
